import React from 'react'
import { Link } from 'react-router-dom'
import './RegistrationLayout.css'

const RegistrationLayout = (props) => {
    return (
        <section className="container-lg">
            <div className="registration">
                <Link to="/">
                    <img
                        className="brandLogo"
                        src="./assets/svg/brandLogo.svg"
                        alt="Jafza eZone logo"
                    />
                </Link>
                <div className="plBox">
                    {/* <form action=""> */}
                    <div className="text-center">
                        <h2>{'Welcome to Jafza Ezone'}</h2>
                        {location.pathname === '/registration' ? (
                            <h4>{'Select Type of Registration'}</h4>
                        ) : (
                            <h4>{'Create Your Free Account'}</h4>
                        )}
                    </div>
                    {props.children}
                    {/* </form> */}
                </div>
            </div>
        </section>
    )
}

export default RegistrationLayout
